import { Typography, Collapse, Icon, Grid } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import ColoredFormattedNumberForeign from 'components/ColoredFormattedNumberForeign';
import MyTable, { MyTableBody, MyTableRow, MyTableCol, MyTableHeader } from 'components/MyTable';
import Spin from 'components/Spin';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { loadMyFutureExtract, loadExtractItems } from 'store/Orbita/Financial/actions';

import styles from '../styles';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  extract: any;
  isFetching: boolean;
  itemsFuture: any;
}

class FutureTable extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      openFuture: false,
      itemValue: {
        isFetching: true,
      },
    };
  }

  componentDidMount() {
    (async () => {
      try {
        await this.props.dispatch(loadMyFutureExtract());
      } catch (error) {
        toast.error('Ops, erro ao carregar o extrato futuro');
      }
    })();
  }

  handleClick = (id: any, date: any) => {
    const dateValeu = date;

    if (id === this.state.openFuture) {
      return this.setState({ openFuture: null });
    }

    this.setState({
      openFuture: id,
      date: dateValeu,
    });

    if (date && date !== this.state.date) {
      this.setState({
        itemValue: {
          isFetching: true,
        },
      });

      (async () => {
        try {
          await this.props.dispatch(loadExtractItems(moment(date).format('YYYY-MM-DD')));

          this.setState({
            itemValue: this.props.itemsFuture,
          });
        } catch (error) {
          toast.error(error);
        }
      })();
    }
  };

  componentDidUpdate(prevProps: any) {
    const { extract } = this.props;
    if (prevProps.extract !== extract) {
      this.setState({
        open: false,
      });
    }
  }

  render() {
    const { classes, extract, isFetching } = this.props;
    const { itemValue } = this.state;

    const indexes = [
      { title: 'Data', ordering: false },
      { title: 'Descrição', ordering: false },
      { title: 'Valor', ordering: false, numeric: true },
      { title: '', ordering: false },
    ];

    const indexesCollapse = [
      { title: 'Descrição', ordering: false },
      { title: 'Valor', ordering: false, numeric: true },
    ];

    return (
      <div className={classes.wrapper}>
        <Grid container justify='space-between' className={classes.tableTitle}>
          <Grid item>
            <Typography className={classes.tableTitleText}>
              Lançamentos Futuros
              {isFetching && ' (Carregando...)'}
              {!isFetching && extract && extract.length > 0 && extract[0].currency.code && ` (${extract[0].currency.code})`}
            </Typography>
          </Grid>
        </Grid>

        <div className={classes.scroll}>
          {isFetching && (
            <div style={{ width: '100%', textAlign: 'center' }}>
              <Spin />
            </div>
          )}

          {!isFetching && extract && (
            <Fragment>
              <MyTable>
                <MyTableHeader index={indexes} />

                <MyTableBody>
                  {extract && extract.length === 0 && !extract.isFetching && (
                    <MyTableRow>
                      <MyTableCol screenSizes={{ xs: 12, sm: 12 }} colSpan={5}>
                        Você não possui lançamentos futuros
                      </MyTableCol>
                    </MyTableRow>
                  )}

                  {extract &&
                    extract.length > 0 &&
                    extract.map((item: any, index: number) => {
                      return (
                        <Fragment key={index}>
                          <MyTableRow hover={true} onClick={() => this.handleClick(index, item.date)}>
                            <MyTableCol screenSizes={{ xs: 12, sm: 2 }}>{moment(item.date).format('L')}</MyTableCol>
                            <MyTableCol screenSizes={{ xs: 12, sm: 7 }}>Créditos/débitos como Produtor/Afiliado</MyTableCol>
                            <MyTableCol numeric screenSizes={{ xs: 12, sm: 2 }}>
                              <ColoredFormattedNumber value={item.daily_balance} format={item.currency.code} />
                              <ColoredFormattedNumberForeign value={item.daily_balance_origin_currency} separator=' / ' />
                            </MyTableCol>
                            <MyTableCol numeric action screenSizes={{ xs: 12, sm: 1 }} style={{ cursor: 'pointer' }}>
                              {(this.state.openFuture === index ? true : false) ? <Icon>expand_less</Icon> : <Icon>expand_more</Icon>}
                            </MyTableCol>
                          </MyTableRow>

                          {(this.state.openFuture === index ? true : false) && (
                            <MyTableRow style={{ padding: 0 }}>
                              <MyTableCol style={{ padding: 0 }} colSpan={4} screenSizes={{ xs: 12, sm: 12 }}>
                                <Collapse in={true}>
                                  <MyTable>
                                    <MyTableHeader index={indexesCollapse} />

                                    <MyTableBody>
                                      {itemValue && itemValue.isFetching && (
                                        <MyTableRow>
                                          <MyTableCol screenSizes={{ xs: 12, sm: 12 }} colSpan={2}>
                                            <Spin />
                                          </MyTableCol>
                                        </MyTableRow>
                                      )}

                                      {itemValue && itemValue.length === 0 && !itemValue.isFetching && (
                                        <MyTableRow>
                                          <MyTableCol screenSizes={{ xs: 12, sm: 12 }} colSpan={2}>
                                            Nenhum resultado encontrado
                                          </MyTableCol>
                                        </MyTableRow>
                                      )}

                                      {itemValue &&
                                        itemValue.length > 0 &&
                                        !itemValue.isFetching &&
                                        itemValue.map((item: any, index: number) => {
                                          return (
                                            <MyTableRow key={item.id}>
                                              <MyTableCol
                                                screenSizes={{ xs: 12, sm: 2 }}
                                                style={{
                                                  borderRadius: index === itemValue.length - 1 ? '' : 0,
                                                  borderBottom: index === itemValue.length - 1 ? '0' : '1px solid #e2e2e2',
                                                }}
                                              >
                                                {item.description}
                                              </MyTableCol>
                                              <MyTableCol
                                                numeric
                                                screenSizes={{ xs: 12, sm: 2 }}
                                                style={{
                                                  borderRadius: index === itemValue.length - 1 ? '' : 0,
                                                  borderBottom: index === itemValue.length - 1 ? '0' : '1px solid #e2e2e2',
                                                }}
                                              >
                                                <ColoredFormattedNumber value={item.value} format='BRL' />
                                                <ColoredFormattedNumberForeign value={item.value_origin_currency} separator=' / ' />
                                              </MyTableCol>
                                            </MyTableRow>
                                          );
                                        })}
                                    </MyTableBody>
                                  </MyTable>
                                </Collapse>
                              </MyTableCol>
                            </MyTableRow>
                          )}
                        </Fragment>
                      );
                    })}
                </MyTableBody>
              </MyTable>

              <div style={{ textAlign: 'right', padding: '0.5rem 0', fontSize: '14px' }}>
                Total a liberar:{' '}
                <ColoredFormattedNumber
                  format='BRL'
                  value={extract && extract.length > 0 && extract.reduce((a: any, b: any) => a + b.daily_balance, 0)}
                />
              </div>
              <div style={{ textAlign: 'right', padding: '0.5rem 0', fontSize: '14px' }}>
                <ColoredFormattedNumberForeign
                  value={extract && extract.length > 0 && extract.reduce((a: any, b: any) => a + b.daily_balance_origin_currency, 0)}
                  separator='Total a liberar: '
                />
              </div>
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    extract: state.orbita.Financial.myFutureExtract.data,
    isFetching: state.orbita.Financial.myFutureExtract.isFetching,
    itemsFuture: state.orbita.Financial.extractItems,
  };
}

export default connect(mapStateToProps)(styles(FutureTable));
